import axios from '@/framework/router/axios'

const remoteDic = {
  mounted() {
    if (this.column.dicOption === '2') {
      this.apiRemote()
    }
  },
  methods: {
    apiRemote() {
      const {
        dicUrl,
        dicMethod
      } = this.column
      axios({
        method: dicMethod,
        url: dicUrl
      }).then(res => {
        this.dicData = res.data
      })
    }
  }
}

export default remoteDic
